import svgIconComponent from '@/components/baseIcon/install'
import 'virtual:svg-icons-register'
import 'animate.css'

export const setupSvgIcon = app => {
    app.use(svgIconComponent)
}
